import React from 'react';

const NotFound = () => {
    return (
        <div className='justify-content-center align-items-center'>
            <p className='text-center'>page not found 404</p>
            <img src="https://thumbs.dreamstime.com/b/lazy-overweight-woman-sleeping-training-mat-gym-lazy-overweight-woman-sleeping-training-mat-176190745.jpg" alt="" />
        </div>
    );
};

export default NotFound;